import { alertI18nEnUs } from '@luigiclaudio/ga-baseline-ui/alert';
import { authI18nEnUs } from '@luigiclaudio/ga-baseline-ui/auth';
import { buttonI18nEnUs } from '@luigiclaudio/ga-baseline-ui/button';
import { commerceI18nEnUs } from '@luigiclaudio/ga-baseline-ui/commerce';
import { formI18nEnUs } from '@luigiclaudio/ga-baseline-ui/form';
import { footerI18nEnUs } from '@luigiclaudio/ga-baseline-ui/footer';
import { headerI18nEnUs } from '@luigiclaudio/ga-baseline-ui/header';
import { modalI18nEnUs } from '@luigiclaudio/ga-baseline-ui/modal';
import { validationI18nEnUs } from '@luigiclaudio/ga-baseline-ui/validation';

const baselineUIMessagesEnUs = {
    ...alertI18nEnUs,
    ...authI18nEnUs,
    ...buttonI18nEnUs,
    ...commerceI18nEnUs,
    ...formI18nEnUs,
    ...footerI18nEnUs,
    ...headerI18nEnUs,
    ...modalI18nEnUs,
    ...validationI18nEnUs,
};

export default baselineUIMessagesEnUs;
